import type { SubscriberLocale } from "@/locales/fr/subscriber";

import { ECivility } from "@/types/backoffice/dto/subscriber/civility-dto.ts";
import {
  ESubscriberSearchField,
  ESubscriberSearchFilterType,
} from "@/types/backoffice/dto/subscriber/subscriber-search-dto";

const subscriberLocale: SubscriberLocale = {
  subscriber: {
    agreementLabel: "Agreement",
    attach: "Attach a subscriber",
    create: "Create a subscriber",
    creation: "Subscriber creation",
    attachExistingSubscriber: "Attach to an existing subscriber",
    agreement: {
      pdlMissing: "PDL is required for sending an agreement letter",
      mailMissing: "An email is required for sending an agreement letter",
      sendAgreementLetter: "Send an agreement letter via mail",
    },
    transferSignature: {
      button: "Request transfer signature",
      openSignature: "Open signature",
      cancelSignature: "Cancel signature",
      loading: "Loading subscriber details...",
      loadError: "Unable to load required information.",
      missingDataIntro: "Missing information required for signature:",
      missingFirstName: "First name",
      missingLastName: "Last name",
      missingPhone: "Default phone",
      missingEmail: "Default email",
      missingPdl: "PDL",
      pendingSignature: "Signature pending",
      modalTitle: "Request transfer signature",
      modalDescription: "Review subscriber details before generating the signature.",
      fields: {
        name: "Name",
        phone: "Phone",
        email: "Email",
        pdl: "PDL",
      },
      optionsTitle: "Consents",
      optionUpgradeToPremium: "Would you like to upgrade your membership to a premium membership?",
      optionAcceptEnergyOffers:
        "Receive by email, with no obligation, other energy efficiency service offers provided by Voltalis",
      optionAcceptPartnerOffers: "Receive by email commercial offers from partners selected by Voltalis",
      confirm: "Generate and open Yousign",
      cancel: "Cancel",
    },
    noSubscriber: {
      title: "No subscriber",
      desc: "No subscriber is linked to site",
      cta: "Attach a subscriber",
    },
    myvAccess: {
      title: "MyV access",
      redirect: "You will be redirected to the MyVoltalis personal area of the subscriber.",
      agreement: "His/her consent is mandatory to access it, and this action on your part will be recorded.",
      cta: "Access to MyVoltalis area",
      cancel: "Cancel",
      error: "An error occurred during redirection",
    },
    myv: "Subscriber's MyV",
    editSubscriber: "Update subscriber",
    edit: "Subscriber Edit",
    civility: "Civility",
    firstname: "First name",
    lastname: "Last name",
    mailMissingPassword: "An email is required for sending a new password",
    sendPassword: "Send a new password",
    psb: "PSB",
    vip: "VIP",
    subscription: "Subscription",
    subscriptionPremium: "Premium Service",
    subscriptionPremiumPendingSignature: "Premium Service (waiting for signature)",
    subscriptionBasic: "Basic Service ",
    myvBasic: "MyVoltalis Basic",
    subscriberOfferModal: {
      title: "You confirm that your contact is opting out of the premium service, which include:",
      features: {
        base: "The {boldText} (consumption tracking, scheduling, absence detection)",
        boldText: "advanced thermostat features",
      },
      support: {
        base: "{boldText} (dedicated phone line or email)",
        boldText: "7-day support",
      },
      warranty: {
        base: "The {boldText}",
        boldText: "unlimited warranty",
      },
      expert: {
        base: "Consultations with experts to {boldText}",
        boldText: "optimize your energy savings",
      },
      buttons: {
        premiumService: "Keep premium service",
      },
    },
    unsetPrivileged: "Unset from PSB",
    setPrivileged: "Add to PSB",
    unsetVIP: "Remove VIP tag",
    setVIP: "Add VIP tag",
    mail: "Email",
    additionalMail: "Additional Emails",
    phone: "Phone",
    additionalPhone: "Additional Phones",
    civilities: {
      [ECivility.MALE]: "Mister",
      [ECivility.FEMALE]: "Madam",
      [ECivility.MISS]: "Miss",
      [ECivility.UNKNOWN]: "Unknown",
    },
    filterTypes: {
      [ESubscriberSearchFilterType.EQUALS]: "Equals...",
      [ESubscriberSearchFilterType.CONTAINS]: "Contains...",
      [ESubscriberSearchFilterType.STARTS_BY]: "Starts by...",
      [ESubscriberSearchFilterType.ENDS_BY]: "Ends by...",
    },
    fields: {
      [ESubscriberSearchField.ID]: "Subscriber ID",
      [ESubscriberSearchField.LASTNAME]: "Lastname",
      [ESubscriberSearchField.FIRSTNAME]: "Firstname",
      [ESubscriberSearchField.EMAIL]: "Email",
      [ESubscriberSearchField.PHONE]: "Phone number",
    },
  },
};

export default subscriberLocale;
